module.exports = __webpack_public_path__ + "static/media/logo-white.03b2340a.svg";